import React from 'react';
import { Shield } from 'lucide-react';

const Privacy = () => {
  return (
    <div className="min-h-screen text-white pt-20 md:pt-32">
      {/* Hero Section - Adapté pour mobile */}
      <div className="container mx-auto px-4 mb-8 md:mb-16">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 md:w-16 md:h-16 rounded-xl bg-[#017D7E]/10 flex items-center justify-center mx-auto mb-4 md:mb-6">
            <Shield className="w-6 h-6 md:w-8 md:h-8 text-[#017D7E]" />
          </div>
          <h1 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6">
            Politique de Confidentialité
          </h1>
          <p className="text-base md:text-xl text-white/70">
            Dernière mise à jour : 15 décembre 2024
          </p>
        </div>
      </div>

      {/* Content - Adapté pour mobile */}
      <div className="container mx-auto px-4 mb-8 md:mb-16">
        <div className="max-w-3xl mx-auto prose prose-invert">
          <div className="bg-white/5 rounded-xl p-4 md:p-8 border border-white/10 space-y-6 md:space-y-8">
            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">Introduction</h2>
              <p className="text-sm md:text-base text-white/70">
                KG Technologies s'engage à protéger la confidentialité de ses utilisateurs. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos données personnelles.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">Collecte des Données</h2>
              <p className="text-sm md:text-base text-white/70 mb-3 md:mb-4">
                Nous collectons les informations suivantes :
              </p>
              <ul className="list-disc pl-4 md:pl-6 space-y-1 md:space-y-2 text-sm md:text-base text-white/70">
                <li>Informations d'identification (nom, email, téléphone)</li>
                <li>Données d'utilisation de nos services</li>
                <li>Informations techniques (adresse IP, cookies)</li>
                <li>Données de transaction et facturation</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">Utilisation des Données</h2>
              <p className="text-sm md:text-base text-white/70 mb-3 md:mb-4">
                Nous utilisons vos données pour :
              </p>
              <ul className="list-disc pl-4 md:pl-6 space-y-1 md:space-y-2 text-sm md:text-base text-white/70">
                <li>Fournir et améliorer nos services</li>
                <li>Personnaliser votre expérience</li>
                <li>Communiquer avec vous</li>
                <li>Assurer la sécurité de nos services</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">Protection des Données</h2>
              <p className="text-sm md:text-base text-white/70">
                Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">Vos Droits</h2>
              <p className="text-sm md:text-base text-white/70 mb-3 md:mb-4">
                Vous disposez des droits suivants concernant vos données :
              </p>
              <ul className="list-disc pl-4 md:pl-6 space-y-1 md:space-y-2 text-sm md:text-base text-white/70">
                <li>Droit d'accès et de rectification</li>
                <li>Droit à l'effacement</li>
                <li>Droit à la limitation du traitement</li>
                <li>Droit à la portabilité des données</li>
                <li>Droit d'opposition au traitement</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">Cookies</h2>
              <p className="text-sm md:text-base text-white/70">
                Notre site utilise des cookies pour améliorer votre expérience de navigation. Vous pouvez contrôler l'utilisation des cookies via les paramètres de votre navigateur. Pour plus d'informations, consultez notre politique en matière de cookies.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4">Modifications</h2>
              <p className="text-sm md:text-base text-white/70">
                Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Les modifications entrent en vigueur dès leur publication sur notre site. Nous vous encourageons à consulter régulièrement cette page.
              </p>
            </section>

            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;